import styled from '@emotion/styled'

const ButtonSpan = styled.span`
  border-color: #9a9da3;
  background-color: #00c4cc;
  color: #ffffff;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-family: 'Open Sans', sans-serif;
  font-weight: 600;
  line-height: 1.6;
  box-sizing: border-box;
  user-select: none;
  cursor: pointer;
  border: 1px solid transparent;
  max-width: 100%;
  min-width: 80px;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  white-space: nowrap;
  transition: background-color 0.1s linear;
  height: 40px;
  border-radius: 4px;
  font-size: 14px;
  padding-right: 16px;

  &:hover {
    background-color: #00d9e1;
  }

  &:active {
    background-color: #00afb5;
  }
`

const Icon = styled.img`
  margin: 0 10px;
  width: 20px;
  color: white;
`

const CanvaIcon = () => {
  return (
    <ButtonSpan>
      <Icon
        alt={'Canva icon'}
        src={
          "data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'%3E%3Cpath fill='%23fff' d='M12 22a10 10 0 1 1 0-20 10 10 0 0 1 0 20zm5-7.7c0-.2-.2-.3-.4-.3s-.3 0-.4.2l-.1.2-.1.1c-.6 1-1.1 1.3-2.2 1.9a4 4 0 0 1-1.7.3c-1.7 0-2.6-1.3-3-2.5-.5-2 .4-4.6 1.6-6 .7-.9 1.5-1.4 2.2-1.4.3 0 .7.2 1 .5.3.6.4 1 0 1.9 0 .2 0 .4.2.5.3 0 .6 0 1-.6.4-.5.4-1.4 0-2A3 3 0 0 0 12.7 6c-.8 0-1.5.2-2.1.6a7.5 7.5 0 0 0-3.4 8 4.7 4.7 0 0 0 4.4 3.4c1.4 0 2.4-.5 3-1 .8-.4 1.4-1 2-1.8l.1-.2.2-.2v-.5z'/%3E%3C/svg%3E"
        }
      />
      Design with Canva
    </ButtonSpan>
  )
}

export default CanvaIcon
